import React, { Component } from "react";
import { Link } from "react-router-dom";

class QVFourTestimonial extends Component {
  testimonialSectionRef = React.createRef();
  hasScrolledToMissingTestimonial = false;

  componentDidMount = () => {
    if (this.props.printVersion) {
      require("./print.scss");
    } else {
      require("./editor.scss");
    }
    this.scrollToMissingTestimonialIfNeeded();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.testimonials !== this.props.testimonials) {
      this.scrollToMissingTestimonialIfNeeded();
    }
  }

  isMissingTestimonials = () => {
    const { testimonials } = this.props;
    return (
      testimonials === "none" ||
      testimonials === null ||
      !testimonials ||
      !testimonials.testimonialContent
    );
  };

  scrollToMissingTestimonialIfNeeded = () => {
    const { fromEditor } = this.props;
    if (
      !fromEditor ||
      this.hasScrolledToMissingTestimonial ||
      !this.isMissingTestimonials()
    ) {
      return;
    }

    this.hasScrolledToMissingTestimonial = true;
    // Parent PMA pages scroll to top on mount; wait so we land on this section.
    window.setTimeout(() => {
      if (this.testimonialSectionRef.current) {
        this.testimonialSectionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 400);
  };

  render() {
    const {
      testimonials,
      agentData,
      printVersion,
      fromEditor,
      currentArea,
      tallerStyles,
      showAllEditButtons,
    } = this.props;
    const { mlsAreaID } = currentArea;
    const { listgenUserID } = agentData;
    let showButton = fromEditor && showAllEditButtons;
    let showTitle = true;
    if (listgenUserID === "102843") {
      showTitle = false;
    }
    if (
      testimonials === "none" ||
      testimonials === null ||
      !testimonials ||
      !testimonials.testimonialContent
    ) {
      return (
        <div
          ref={this.testimonialSectionRef}
          className={
            printVersion
              ? "print-april-2023-qv4-testimonial no-testimonial-available"
              : "editor-april-2023-qv4-testimonial no-testimonial-available"
          }
        >
          {fromEditor && (
            <Link to="/agent/clienttestimonials">
              <div className="qv4-testimonial-text-container">
                <div className="testimonial-content-row">
                  <div className="add-testimonial-text">
                    Please add at least one client Testimonial to your profile
                    page.
                    <br />
                    Click HERE!
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
      );
    } else {
      let { clientFirstName, clientLastName, testimonialContent } =
        testimonials;
      if (mlsAreaID === "CCA-4500M") {
        testimonialContent =
          "Exceeded all expectations! Sue Rubin and Mike O’Brien are outstanding listing agents. Their work and Concierge Services helped my home sell for 14% over list price, setting a record for my model. They truly increase equity and resale values. Hands down, they are the community’s trusted real estate team and partner in profit.";
        clientFirstName = "Crow Canyon";
        clientLastName = "Seller";
      }
      // if (listgenUserID === "102843") {
      //   testimonialContent =
      //     "I have nothing but praise for Michael Galli and his excellent team. They are thorough, attentive, efficient and prompt—all things that you want when you are planning to buy or sell your house.";
      //   if (mlsAreaID === "SCL-209A") {
      //     clientFirstName = "Recent Cuesta Park Sellers";
      //     clientLastName = "— June 19";
      //   } else {
      //     clientFirstName = "Recent Mountain View Sellers";
      //     clientLastName = "— June 19";
      //   }
      // }

      const testimonialLength = testimonialContent.length;
      let testimonialTextStyles;
      let testimonialContainerStyles;
      if (listgenUserID === "106024") {
        testimonialTextStyles = "testimonial-text-14";
      } else if (testimonialContent && testimonialLength > 400) {
        testimonialTextStyles = "testimonial-medium-text";
      } else if (listgenUserID === "102843") {
        testimonialTextStyles = "testimonial-text-19";
      }

      // if (tallerStyles) {
      //   testimonialContainerStyles = "taller-testimonial";
      // }
      let clientNameLength = 0;
      if (clientFirstName && clientLastName) {
        clientNameLength =
          (clientFirstName.length || 0) + (clientLastName.length || 0);
      }

      if (clientFirstName === null || listgenUserID === "105801") {
        clientFirstName = false;
        console.log("is null");
      }

      return (
        <div
          className={`
            ${
              printVersion
                ? `print-april-2023-qv4-testimonial ${testimonialContainerStyles}`
                : `editor-april-2023-qv4-testimonial ${testimonialContainerStyles}`
            }
          `}
        >
          {showButton && (
            <Link
              to="/agent/clienttestimonials"
              className="testimonial-edit-page-button"
            >
              Edit Testimonial
            </Link>
          )}

          <div className="qv4-testimonial-text-container">
            {!showTitle ? (
              ""
            ) : listgenUserID === "106543" ? (
              <div className="qv4-testimonial-title">Client Testimonial:</div>
            ) : listgenUserID === "104412" ? (
              <div className="qv4-testimonial-title">
                I LET MY CLIENTS DO THE TALKING
              </div>
            ) : listgenUserID === "105100" ||
              listgenUserID === "106024" ||
              listgenUserID === "105801" ? (
              ""
            ) : listgenUserID === "102843" ? (
              <div className="qv4-testimonial-title">Spreading client love</div>
            ) : (
              <div className="qv4-testimonial-title">Earning Your Trust</div>
            )}

            <div className="testimonial-content-row">
              {listgenUserID === "102843" && (
                <div className="mq3-testimonial-quotation start-quote">"</div>
              )}
              {listgenUserID === "102843" ? (
                <div
                  className={`qv4-testimonial-text ${testimonialTextStyles}`}
                >
                  I have nothing but praise for Michael Galli and his excellent
                  team. They are{" "}
                  <strong> thorough, attentive, efficient and prompt</strong>
                  —all things that you want when you are planning to buy or sell
                  your house.
                </div>
              ) : (
                <div
                  className={`qv4-testimonial-text ${testimonialTextStyles}`}
                >
                  {testimonialContent}{" "}
                </div>
              )}
              {listgenUserID === "102843" && (
                <div className="mq3-testimonial-quotation end-quote">"</div>
              )}
            </div>
            {clientFirstName && (
              <div
                className={`qv4-testimonial-signoff ${
                  clientNameLength > 42 && "shorter-margin-signoff"
                } ${testimonialTextStyles}`}
              >
                ~ {clientFirstName} {clientLastName}
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

export default QVFourTestimonial;
